<button
  role="button"
  [class]="classes"
  tabindex="0"
  [type]="type ? type : 'button'"
  [attr.disabled]="disabled ? '' : null"
  [attr.data-automation]="text"
>
  <span class="label">{{ text }}</span>
  <ng-content></ng-content>
</button>
